import React from 'react';

import './InvitePendingIcon.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  fontSize: string;
};

function InvitePendingIcon({ fontSize = '17px' }: Props) {
  return (
    <span className="invite-pending-icon " aria-hidden="true" style={{ fontSize }}>
      <WpIcon name="smile" />
    </span>
  );
}

export default InvitePendingIcon;
